var site = site || {};
var generic = generic || {};
var pwr = pwr || {};
var pr_loyaltymember2 = '0', pr_iamamacproartist2 = '', pr_iamamacselectmember2 = '';

(function ($) {
  var signIn = false;
  var productName;

  Drupal.behaviors.writeReview = {
    renderForm: function (args) {
      args = args || { };
      var variant = variant || '';
      var context = args.context;
      var user = args.user;
      var that = this;

      if (pwr && typeof Drupal.settings.power_reviews !== 'undefined' && typeof generic !== 'undefined' && typeof generic.env !== 'undefined' && typeof generic.env.query !== 'undefined' && typeof context !== 'undefined') {
        var $writeReviewContainer = $('#power_review_container', context);
        var product_id = 'PROD' + generic.env.query('pr_page_id');
        var params = [
          {
            'products': [product_id],
            'category_fields': ['products'],
            'product_fields': ['PROD_RGN_NAME', 'shaded', 'SHORT_DESC', 'SUB_LINE', 'LARGE_IMAGE', 'url', 'skus'],
            'sku_fields': ['SKU_ID', 'SHADENAME', 'IMAGE_LARGE']
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();

            if (typeof productDetails.products !== 'undefined') {
              var productName = typeof Drupal.settings.power_reviews.show_translation_title !== 'undefined' && Drupal.settings.power_reviews.show_translation_title ? productDetails.products[0].SUB_LINE : productDetails.products[0].PROD_RGN_NAME;
              var isShaded = productDetails.products[0].shaded;
              var productImageSrc;
              if (Drupal.settings.globals_variables.images_cr21) {
                productImageSrc = typeof productDetails.products[0].skus[0].IMAGE_LARGE === 'object' ? productDetails.products[0].skus[0].IMAGE_LARGE[0] : productDetails.products[0].skus[0].IMAGE_LARGE;
              } else {
                productImageSrc = typeof productDetails.products[0].LARGE_IMAGE === 'object' ? productDetails.products[0].LARGE_IMAGE[0] : productDetails.products[0].LARGE_IMAGE;
              }
              var productImageUrl = productDetails.products[0].url;
              var $prodImageContainer = $('.js-product-image', $writeReviewContainer);

              $prodImageContainer.attr('src', productImageSrc).attr('alt', productName);
              if (typeof site.client.isMobile !== 'undefined' && site.client.isMobile) {
                $prodImageContainer.addClass('hidden');
              }
              $('.js-product-image-link', $writeReviewContainer).attr('href', productImageUrl);
              $('.js-pr-product-name', $writeReviewContainer).html(productName);
              if (Drupal.settings.power_reviews.show_sub_line) {
                var subLine = productDetails.products[0].SHORT_DESC;

                $('.js-pr-sub-line', $writeReviewContainer).html(subLine);
              }
              if (isShaded) {
                var i;
                var page_id_variant = generic.env.query('pr_skuId');
                var optionList = productDetails.products[0];
                var selectText = $('.js-select-one', $writeReviewContainer).text();
                var othersText = $('.js-others', $writeReviewContainer).text();

                $('.js-pr-shade-label').removeClass('hidden');
                var combo = $('<select></select>').attr('id', 'variant-selector').attr('name', 'variant-selector').attr('class', 'js-variant-selector');
                var alphabetizedSkus = _.sortBy(optionList.skus, 'SHADENAME');

                if (page_id_variant) {
                  $('<option />', {
                    value: '',
                    text: selectText,
                    disabled: 'disabled'
                  }).appendTo(combo);
                  for (i = 0; i < alphabetizedSkus.length; i++) {
                    if (page_id_variant === alphabetizedSkus[i].SKU_ID) {
                      $('<option />', {
                        value: alphabetizedSkus[i].SKU_ID,
                        text: alphabetizedSkus[i].SHADENAME,
                        selected: 'selected'
                      }).appendTo(combo);
                    } else {
                      $('<option />', {
                        value: alphabetizedSkus[i].SKU_ID,
                        text: alphabetizedSkus[i].SHADENAME
                      }).appendTo(combo);
                    }
                  }
                  $('<option />', {
                    value: 'null',
                    text: othersText
                  }).appendTo(combo);
                  $('.js-pr-dropdown', $writeReviewContainer).append(combo);
                  that.renderWriteAReviewForm(page_id_variant, user);
                } else {
                  $('<option />', {
                    value: '',
                    text: selectText,
                    disabled: 'disabled',
                    selected: 'selected'
                  }).appendTo(combo);
                  for (i = 0; i < alphabetizedSkus.length; i++) {
                    $('<option />', {
                      value: alphabetizedSkus[i].SKU_ID,
                      text: alphabetizedSkus[i].SHADENAME
                    }).appendTo(combo);
                  }
                  $('<option />', {
                    value: 'null',
                    text: othersText
                  }).appendTo(combo);
                  $('.js-pr-dropdown', $writeReviewContainer).append(combo);
                  that.renderWriteAReviewForm(null, user);
                }
                $('.js-variant-selector', $writeReviewContainer).change(function () {
                  var variant = $(this).val();
                  that.renderWriteAReviewForm(variant, user);
                });
              } else {
                that.renderWriteAReviewForm(variant, user);
              }
            }
          }
        });
      }
    },
    renderWriteAReviewForm: function (variant, user) {
      var page_id = generic.env.query('pr_page_id');
      // Mac CA FR Config Changes
      var pr_locale = document.location.hostname.search('fr.maccosmetics.ca') !== -1 ? Drupal.settings.power_reviews.locale_fr : Drupal.settings.power_reviews.locale;
      var pr_merchant_id = document.location.hostname.search('fr.maccosmetics.ca') !== -1 ? Drupal.settings.power_reviews.merchant_id_fr : Drupal.settings.power_reviews.merchant_id;
      var continue_shopping_url = window.location.protocol + '//' + document.location.hostname + (typeof Drupal.settings.power_reviews.continue_shopping !== 'undefined' ? Drupal.settings.power_reviews.continue_shopping : '');
      var locales = $.cookie('LOCALE');

      if (locales && locales !== '') {
        locales = locales.toLowerCase();
        if (typeof Drupal.settings.power_reviews[locales] !== 'undefined' && typeof Drupal.settings.power_reviews[locales]['merchant_id'] !== 'undefined' && typeof Drupal.settings.power_reviews[locales]['locale'] !== 'undefined') {
          pr_merchant_id = Drupal.settings.power_reviews[locales]['merchant_id'];
          pr_locale = Drupal.settings.power_reviews[locales]['locale'];
        }
      }

      var pr_args = {
        api_key: Drupal.settings.power_reviews.api_key,
        locale: pr_locale,
        merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
        merchant_id: pr_merchant_id,
        page_id_variant: variant,
        page_id: page_id,
        on_submit: function (config, data) {
          if (config.component === 'WriteAReview') {
            $('.js-pr-dropdown').addClass('hidden');
            $('.js-pr-war-heading').addClass('hidden');
            $('.js-pr-shade-label').addClass('hidden');
          }
        },
        components: {
          Write: 'pr-write'
        }
      };

      $('.js-pr-war-heading').removeClass('hidden');
      $('.js-review-container').removeClass('hidden');
      if (typeof user !== 'undefined' && typeof user.user_id !== 'undefined') {
        pr_args.merchant_user_id = user.user_id;
      }
      if (typeof user !== 'undefined' && typeof user.is_loyalty_member !== 'undefined' && user.is_loyalty_member) {
        pr_loyaltymember2 = '1';
        pr_iamamacselectmember2 = $('.js-elist-member', $('.write_a_review__container')).html();
      }
      if (typeof user !== 'undefined' && typeof user.is_pro !== 'undefined' && user.is_pro) {
        pr_iamamacproartist2 = $('.js-pro-member', $('.write_a_review__container')).html();
      }

      pr_args.return_url = continue_shopping_url;
      pr_args.on_submit = function (config, data) {
        $(window).scrollTop(0);
        $('.js-war-heading', $('.write_a_review__container')).addClass('hidden');
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
          site.track.reviewWriteEnd({
            product_impression_id: 'PROD' + page_id,
            product_impression_name: productName
          });
        }
      };
      pr_args.on_render = function (config, data) {
        var is_loyalty_member = user.is_loyalty_member;
        var $reviewContainer = $('.js-pr-write');
        var $emailField = $('#pr-email_collection-input', $reviewContainer);
        var mailValue = $emailField[0].value;
        var tracker = $emailField[0]._valueTracker;
        var userEmail = $('.js-return-user-email').eq(0).val();
        var inputEvent = new Event('input', { bubbles: true });
        if (is_loyalty_member) {
          $('#pr-iamamacselectmember .pr-btn-default').addClass('active').attr('aria-checked', true);
          $('.pr-btn-default:first', $('.pr-loyaltymember-form-group')).addClass('active').attr('aria-checked', true);
        } else {
          $('.pr-btn-default:last', $('.pr-loyaltymember-form-group')).addClass('active').attr('aria-checked', true);
        }
        var is_pro = user.is_pro;

        if (is_pro) {
          $('#pr-iamamacproartist .pr-btn-default').addClass('active').attr('aria-checked', true);
        }

        if (typeof user !== 'undefined' && typeof user.email_address !== 'undefined') {
          $emailField.attr('value', user.email_address);
          tracker.setValue(mailValue);
          $emailField[0].dispatchEvent(inputEvent);
        } else {
          $emailField.attr('value', userEmail)
          tracker.setValue(mailValue);
          $emailField[0].dispatchEvent(inputEvent);
        }

        $reviewContainer.find('.pr-rating-stars div').attr('data-test-id', 'overall_rating_star_select');
        $reviewContainer.find('.pr-bottomline-form-group [role=radio]').attr('data-test-id', 'review_recommend_product_select');
        $reviewContainer.find('.pr-name-form-group .pr-textinput').attr('data-test-id', 'reviewer_name');
        $reviewContainer.find('.pr-location-form-group .pr-textinput').attr('data-test-id', 'reviewer_location');
        $reviewContainer.find('.pr-age-form-group select').attr('data-test-id', 'reviewer_age');
        $reviewContainer.find('.pr-headline-form-group .pr-textinput').attr('data-test-id', 'review_title');
        $reviewContainer.find('.pr-comments-form-group textarea').attr('data-test-id', 'review_text');
        $reviewContainer.find('.pr-productbenefits-form-group .pr-label-control').attr('data-test-id', 'product_benefit_select');
        $reviewContainer.find('.pr-btn-add-tag [role=button]').attr('data-test-id', 'add_your_benefit');
        $reviewContainer.find('.pr-wheredidyoupurchasethisproduct-form-group select').attr('data-test-id', 'purchase_select');
        $reviewContainer.find('.pr-submit .pr-accessible-btn').attr('data-test-id', 'review_submit');
      };
      pwr('render', pr_args);
    },
    triggerSignin: function (args) {
      var context = args.context;
      var signinRequest = args.signinRequest;
      var that = this;
      var paramObj = {};

      if (
        typeof Drupal.settings.power_reviews.skip_offer_process !== 'undefined' &&
        Drupal.settings.power_reviews.skip_offer_process
      ) {
        paramObj.SKIP_OFFER_PROCESS = 1;
      }

      if (signinRequest) {
        var inputVals = $('#power_review_container', context).find('#js-signin-form').serializeArray();

        // loop through all the fields and get the values
        $.each(inputVals, function (index, formObj) {
          paramObj[formObj.name] = formObj.value;
        });
      } else {
        var email = $('.pr_email', context).val();

        paramObj.NEW_USER_EMAIL_ADDRESS = email;
        paramObj._SUBMIT = 'signin_new_user';
        paramObj._SECONDARY_SUBMIT = 'email_promotions';
        paramObj.PC_EMAIL_PROMOTIONS = 0;
      }
      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (r) {
          var userInfo = r.getData().userinfo;

          $('.js-signin-err-msg', context).empty().addClass('hidden');
          $('#pwr_signin', context).addClass('hidden');
          $('.js-naver_container_login', context).addClass('hidden');
          that.renderForm({
            context: context,
            user: userInfo
          });
        },
        onFailure: function (r) {
          var returnUserEmail = $('.js-return-user-email', context).val();
          var messages = r.getMessages();
          var key = messages[0].key;
          var review_error_text = messages[0].text;
          var invalid_error_message_review = $('.invalid-error-message-review').html();

          if (key.match(/format.password/i) && signIn) {
            site.signin.hiddenForm = $('.js-signin-hidden-form', context);
            if (site.signin.hiddenForm) {
              site.signin.submitHiddenSigninForm({
                email: returnUserEmail,
                phone2: '',
                actionURL: '/account/password_request.tmpl?gdpr_return_user=1&EMAIL_ADDRESS=' + encodeURIComponent(returnUserEmail)
              });
            }

            return false;
          }
          if (key === 'invalid.password.signin' && invalid_error_message_review !== '') {
            review_error_text = invalid_error_message_review;
          }
          if (key === 'invalid.privacy.consent') {
            $('.js-adv-legal').removeClass('hidden');
            $('.adv-legal__dpc-label').addClass('error');
          }
          $('.js-signin-err-msg', context).empty().html(review_error_text).removeClass('hidden');
          $('.full_sign_in .btn-pr', context).attr('disabled', false);
          var emailCheckBtn = $('.email_check .btn-pr', context);

          emailCheckBtn.attr('disabled', false);
          that.navigateToPasswordReset(context);
        }
      });
    },
    isValidEmailAddress: function (emailAddress) {
      var atpos = emailAddress.indexOf('@');
      var dotpos = emailAddress.lastIndexOf('.');

      return atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailAddress.length ? false : true;
    },
    attach: function (context) {
      var signedIn = site.userInfoCookie.getValue('signed_in') - 0 === 1;
      var that = this;
      var appName = generic.env.query('appName');

      if (appName) {
        document.title = site.translations.product.ask_and_answer + ' | ' + Drupal.settings.lp.site_name;
      }
      if (signedIn) {
        $(document).on('user.loaded', function (e, user) {
          that.renderForm({
            context: context,
            user: user
          });
        });
      } else {
        if (Drupal.settings.power_reviews.signin_required) {
          var page_id = generic.env.query('pr_page_id');
          var partialSignin = Drupal.settings.power_reviews.partial_signin ?? true;

          // login flow method
          if (partialSignin) {
            $('#pwr_signin', context).removeClass('hidden');
            var pr_valid_email = $('#pr_valid_email', context).html();
            // get product details to show in login page
            var params = [
              {
                products: ['PROD' + page_id],
                category_fields: ['products'],
                product_fields: ['PROD_RGN_NAME', 'LARGE_IMAGE', 'skus'],
                sku_fields: ['IMAGE_LARGE']
              }
            ];

            generic.jsonrpc.fetch({
              method: 'prodcat',
              params: params,
              onSuccess: function (t) {
                var productDetails = t.getValue();

                if (typeof productDetails.products !== 'undefined') {
                  var productImageSrc;

                  productName = productDetails.products[0].PROD_RGN_NAME;
                  var $prodImgContainer = $('#pwr_signin .js-product-image');

                  if (Drupal.settings.globals_variables.images_cr21) {
                    productImageSrc = typeof productDetails.products[0].skus[0].IMAGE_LARGE === 'object' ? productDetails.products[0].skus[0].IMAGE_LARGE[0] : productDetails.products[0].skus[0].IMAGE_LARGE;
                  } else {
                    productImageSrc = typeof productDetails.products[0].LARGE_IMAGE === 'object' ? productDetails.products[0].LARGE_IMAGE[0] : productDetails.products[0].LARGE_IMAGE;
                  }
                  $prodImgContainer.attr('src', productImageSrc).attr('alt', productName).attr('title', productName);
                  if (typeof site.client.isMobile !== 'undefined' && site.client.isMobile) {
                    $prodImgContainer.addClass('hidden');
                  }
                }
              }
            });
            // check whether registered user
            var emailCheckBtn = $('.email_check .btn-pr', context);
            var fullSigninBtn = $('.full_sign_in .btn-pr', context);

            emailCheckBtn.click(function (evt) {
              evt.preventDefault();
              emailCheckBtn.attr('disabled', true);
              var email = $('.pr_email', context).val();

              if (that.isValidEmailAddress(email)) {
                generic.jsonrpc.fetch({
                  method: 'user.registered',
                  params: [{ email_address: email }],
                  onSuccess: function (r) {
                    $('.js-signin-err-msg', context).empty().addClass('hidden');
                    var val = r.getValue();
                    var isUser = (val !== null) && (val === 1);

                    if (isUser) {
                      // show full login
                      $('#pwr_signin .email_check', context).addClass('hidden');
                      $('#pwr_signin .full_sign_in', context).removeClass('hidden');
                      $('#pwr_signin input[name="EMAIL_ADDRESS"]', context).val(email);
                      signIn = isUser;
                      that.navigateToPasswordReset(context);
                    } else {
                      // anonymous write-a-review
                      $('.js-signin-err-msg', context).empty().addClass('hidden');
                      that.triggerSignin({
                        context: context,
                        signinRequest: 0
                      });
                    }
                  },
                  onFailure: function () {
                    emailCheckBtn.attr('disabled', false);
                  }
                });
              } else {
                emailCheckBtn.attr('disabled', false);
                $('.js-signin-err-msg', context).empty().html(pr_valid_email).removeClass('hidden');
              }
            });
            fullSigninBtn.click(function (evt) {
              evt.preventDefault();
              fullSigninBtn.attr('disabled', true);
              var email = $('#js-signin-form input[name="EMAIL_ADDRESS"]', context).val();

              if (that.isValidEmailAddress(email)) {
                $('.js-signin-err-msg', context).empty().addClass('hidden');
                that.triggerSignin({
                  context: context,
                  signinRequest: 1
                });
              } else {
                fullSigninBtn.attr('disabled', false);
                $('.js-signin-err-msg', context).empty().html(pr_valid_email).removeClass('hidden');
              }
            });
          } else {
            var returnUrl = encodeURIComponent(
              document.location.pathname + '?pr_page_id=' + page_id
            );

            if (appName) {
              returnUrl = encodeURIComponent(
                document.location.pathname + '?pr_page_id=' + page_id + '&appName=' + appName
              );
            }
            var signinUrl = '/account/signin.tmpl' + '?RETURN_URL=' + returnUrl;

            document.location.href = signinUrl;
          }
        } else {
          that.renderForm({ context: context });
        }
      }

      if (Drupal.settings.globals_variables.loyalty_reviews_earning) {
        generic.jsonrpc.fetch({
          'method': 'user.recordSocialAction',
          'params': [
            {
              action: 'review',
              url: document.referrer
            }
          ]
        });
      }
    },
    navigateToPasswordReset: function (context) {
      var $forgotPassword = $('.js-forgot-password', context);
      var $signinEmailAddress = $('.js-return-user-email', context);

      if ($forgotPassword.length && $signinEmailAddress.length) {
        site.signin.forgotPassword({
          resetPassword: true,
          emailNode: $signinEmailAddress,
          errorListNode: ' ',
          forgotPasswordLink: $forgotPassword
        });
      }
    }
  };
})(jQuery);
